import type {RequestUserContext} from '../../types/request';

import type {RuntimeWithRequestContext} from './types';

/**
 * Sets the user context for the current request.
 * @param user - The user context to set.
 */
export const setRequestUserContext = (
  user: RequestUserContext | null,
): void => {
  (globalThis as RuntimeWithRequestContext).__otelRequestUserContext = user;
};

/**
 * Gets the user context for the current request.
 * @returns The user context for the current request.
 */
export const getRequestUserContext = (): RequestUserContext | null => {
  return (
    (globalThis as RuntimeWithRequestContext).__otelRequestUserContext ?? null
  );
};
